<template>
  <div class="field">
    <van-field v-model="inputVal" readonly clickable :placeholder="placeholder" class="main-field"
               :disabled="disable || formOption.isReadonly === dictionary.readonlyFlag[0].value"
               :rules="getFormRule(formOption)"
               @click="!disable && formOption.isReadonly !== dictionary.readonlyFlag[0].value?formOption.isPopFlag = true:''"
    >
      <template #right-icon>
        <div v-if="isCloseShow" class="isCloseShow" @click.stop.prevent="deleteData">
          <van-icon name="close" />
        </div>
      </template>
    </van-field>
  </div>
</template>
<script>
import * as dictionary from '@/assets/js/dictionary'
export default {
	props: {
		value: {
			type: Object,
			default: {}
		},
		disable: {
			type: [Number, Boolean],
			default: false
		},
		placeholder: {
			type: String,
			default: ''
		},
		inputData: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			dictionary,
			isCloseShow: true, // input清空按钮状态
			inputVal: ''
		}
	},
	computed: {
		formOption: {
			get: function() {
				return this.value
			},
			set: function() {
				return
			}
		}
	},
	watch: {
		'formOption': {
			handler(newValue) {
				this.inputVal = this.inputData
				this.isCloseShow = !(!newValue.value || newValue.value.length === 0 || this.disable || this.formOption.isReadonly === dictionary.readonlyFlag[0].value)
				this.$emit('changeFieldData', newValue)
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		// 表单校验
		getFormRule(item) {
			if (this.disable) return []
			const rules = [{
				required: item.isRequired === dictionary.requiredFlag[0].value,
				message: `${item.itemName}不能为空`,
				trigger: 'change'
			}]
			if (item.controlType === 'NTX') {
				rules.push({
					validator: (rule, value) => {
						return new Promise((resolve, reject) => {
							if (value) {
								const np = /^(-)?\d+(\.\d+)?$/
								if (!np) {
									this.$toast.fail(`${item.itemName}数字输入有误`)
									reject()
								}
								if (item.allowDecimal === dictionary.allowDecimalType[0]
									.value && item
									.decimalDigit) {
									if (item.value && item.value.toString().indexOf('.') !== -1) {
										if (
											item.value.toString().split('.')[1].length >
                                                item.decimalDigit
										) {
											this.$toast.fail(
												`${item.itemName}仅允许输入${item.decimalDigit}位小数`
											)
											reject()
										}
									}
								} else {
									if (item.value && item.value.toString().indexOf('.') !== -1) {
										this.$toast.fail(`${item.itemName}不允许输入小数`)
										reject()
									}
								}
								const rangeUp = Number(item.rangeUp) > Number(item.rangeDown)
									? Number(
										item
											.rangeUp) : Number(item.rangeDown)
								const rangeDown = Number(item.rangeUp) > Number(item
									.rangeDown)
									? Number(
										item.rangeDown) : Number(item.rangeUp)
								if (item.scopeValid === this.dictionary.scopeValidType[0]
									.value && (Number(item.value) > rangeUp || Number(item
									.value) < rangeDown)) {
									this.$toast.fail(
										`${item.itemName}数值范围输入有误! 数值范围:{${rangeDown}~${rangeUp}}`
									)
									reject()
								}
								resolve()
							}
						})
					},
					trigger: ['change', 'blur']
				})
			}
			return rules
		},
		// 清空输入框
		deleteData() {
			if (this.formOption.controlType === 'SUF' || this.formOption.controlType === 'CB' || this.formOption
				.controlType ===
                    'ADSEL') {
				this.formOption.value = []
			} else {
				this.formOption.value = ''
			}
			this.inputVal = ''
			this.isCloseShow = false
		}
	}
}
</script>